import * as React from 'react';
import { useDebounce } from '@deltasierra/react-hooks';
import { Input } from '../Input';

export type SearchBarProps = {
    placeholder?: string;
    onTermChange?: (val: string) => void;
    onSearch: (val: string) => void;
    style?: React.CSSProperties;
    hasWarning?: boolean;
    warningText?: string;
};

export const SearchBar: React.FunctionComponent<SearchBarProps> = ({
    hasWarning = false,
    onSearch,
    onTermChange,
    placeholder = '',
    style,
    warningText = '',
}) => {
    const [term, setTerm] = React.useState<string>('');
    const throttledSearchTerm = useDebounce(term, 750);

    React.useEffect(() => {
        onSearch(throttledSearchTerm);
    }, [onSearch, throttledSearchTerm]);

    const handleChange = (newTerm: string) => {
        setTerm(newTerm);
        if (onTermChange) {
            onTermChange(newTerm);
        }
    };

    return (
        <div>
            <Input
                clearable
                hasWarning={hasWarning}
                placeholder={placeholder}
                style={style}
                warningText={warningText}
                onTermChange={handleChange}
            />
        </div>
    );
};
SearchBar.displayName = 'SearchBar';
